import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import Heading from '../../components/Heading'
import IconButton from '../../components/IconButton'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import Text from '../../components/Text'
import { useAdmin } from '../../contexts/AdminContext'
import Card from '../../components/Card'
import MediaList from '../../compositions/Settings/MediaSettings/MediaList/MediaList'

const MediaSettings: React.FC = () => {
    const { t } = useTranslation(['settings'])
    const navigate = useNavigate()
    const { subscription } = useAdmin()

    return (
        <>
            <Heading level={3} classes={'zr-my-4'}>
                {t('media.heading')}
            </Heading>
            <IconButton
                icon={faArrowLeft}
                color={'black'}
                onClick={() => navigate('/settings')}
            >
                {t('common.backToOverview')}
            </IconButton>
            <Text classes={'zr-mt-3'}>{t('media.description')}</Text>
            {subscription?.plans.filter(
                (p) => p.slug === 'zr-customizer-mediathek'
            ).length === 0 && (
                <Card style={{ background: '#FFCC0033' }} classes={'zr-mb-4'}>
                    {t('subscription.noMedia')}
                </Card>
            )}
            <div className={'zr-mt-4'}>
                <MediaList />
            </div>
        </>
    )
}

export default MediaSettings
